import { zoomToStage } from './zoom';
import { moveToCenter } from './move';

function resizeToStage(): void {
    zoomToStage();
    moveToCenter();
}

export {
    resizeToStage
};
